"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const common_utils_1 = require("@zapier/common-utils");
const design_system_1 = require("@zapier/design-system");
const MessageBar_1 = __importDefault(require("../../MessageBar"));
const useTimer_1 = __importDefault(require("./useTimer"));
const openAnimation = core_1.keyframes({
    '0%': {
        opacity: 0,
        transform: 'translateY(-10px)',
    },
    '100%': {
        opacity: 1,
        transform: 'translateY(0)',
    },
    '30%': {
        opacity: 0,
        transform: 'translateY(-10px)',
    },
});
const rootStyle = core_1.css `
  animation: ${design_system_1.Animation.transitionDuration} ease-out ${openAnimation};
  max-width: 90vw;
  width: 700px;
`;
function Notification({ notification, onDismiss, timeout }) {
    function handleDismiss() {
        if (notification.onDismiss) {
            notification.onDismiss(notification);
        }
        onDismiss(notification.id);
    }
    const { onPause, onResume } = useTimer_1.default(handleDismiss, timeout);
    return (common_utils_1.isolateComponent("div", { css: rootStyle, onMouseEnter: onPause, onMouseLeave: onResume },
        common_utils_1.isolateComponent(MessageBar_1.default, { onDismiss: handleDismiss, type: notification.type }, notification.message)));
}
exports.default = Notification;
